/* Vivid: the site remains usable without JavaScript. */
(() => {
  document.documentElement.classList.replace('no-js', 'js');
  const menus = document.querySelectorAll('[data-vivid-menu]');
  menus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    const syncLabel = () => summary?.setAttribute('aria-label', menu.open ? 'Close navigation' : 'Open navigation');
    menu.addEventListener('toggle', syncLabel);
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) { menu.open = false; summary?.focus(); }
    });
    document.addEventListener('click', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    window.matchMedia('(min-width: 1050px)').addEventListener('change', (event) => {
      if (event.matches) menu.open = false;
    });
  });
  // Native form submission and Shopify checkout remain authoritative.
  document.querySelectorAll('[data-vivid-product-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      const submit = form.querySelector('[type="submit"]');
      if (submit && form.checkValidity()) submit.setAttribute('aria-busy', 'true');
    });
  });
})();


(() => {
  const normalize = (value) => value.replace(/\s+/g, ' ').trim();
  const words = (node) => normalize(node.textContent || '').split(' ').filter(Boolean).length;
  const splitParagraph = (paragraph) => {
    if (paragraph.id || paragraph.closest('aside, nav, blockquote, table, li, details')) return;
    let safety = 0;
    while (words(paragraph) > 145 && safety++ < 12) {
      const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
      let node;
      let preceding = 0;
      let boundary;
      while ((node = walker.nextNode())) {
        const text = node.textContent;
        if (node.parentElement === paragraph) {
          for (const match of text.matchAll(/[.!?][\u201d\u2019"']?\s+(?=[A-Z0-9])/g)) {
            const offset = match.index + match[0].length;
            const count = preceding + text.slice(0, offset).trim().split(/\s+/).length;
            if (count >= 60 && count <= 115 && words(paragraph) - count >= 35) {
              boundary = {node, offset};
              break;
            }
          }
        }
        if (boundary) break;
        preceding += text.trim().split(/\s+/).filter(Boolean).length;
      }
      if (!boundary) break;
      const range = document.createRange();
      range.setStart(paragraph, 0);
      range.setEnd(boundary.node, boundary.offset);
      const piece = document.createElement('p');
      piece.append(range.extractContents());
      paragraph.before(piece);
    }
  };

  const enhance = (root) => {
    if (root.dataset.readingReady) return;
    const source = root.querySelector('[data-article-body]');
    const host = root.querySelector('[data-reading-content]');
    const route = root.querySelector('[data-reading-route]');
    const routeList = root.querySelector('[data-reading-route-list]');
    if (!source || !host || !route || !routeList) return;
    const working = source.cloneNode(true);
    const explicit = [...working.children].filter(node => node.matches('section[data-vivid-chapter]'));
    const headings = [...working.children].filter(node => node.tagName === 'H2');
    if (explicit.length < 3 && headings.length < 3) return;
    if (explicit.length >= 3 && explicit.some(node => ![...node.children].some(child => child.tagName === 'H2'))) return;
    let chapters = [];
    const opening = document.createElement('div');
    opening.className = 'v2-article-body v3-article-opening';
    if (explicit.length >= 3) {
      for (const node of [...working.childNodes]) {
        if (node.nodeType === 1 && node.matches('section[data-vivid-chapter]')) {
          const heading = [...node.children].find(child => child.tagName === 'H2');
          if (!heading) continue;
          const body = document.createElement('div');
          body.className = 'v2-article-body';
          for (const child of [...node.childNodes]) if (child !== heading) body.append(child);
          chapters.push({heading,body,title:node.dataset.chapterTitle || heading.textContent});
        } else opening.append(node);
      }
    } else {
      const units = [];
      let current;
      for (const node of [...working.childNodes]) {
        if (node.nodeType === 1 && node.tagName === 'H2') {
          current = {heading:node,nodes:[],weight:0};
          units.push(current);
        } else if (current) {
          current.nodes.push(node);
          if (node.nodeType === 1 && !node.matches('nav, aside')) current.weight += words(node);
        } else opening.append(node);
      }
      const total = units.reduce((sum,unit) => sum + unit.weight, 0);
      let best = {score:Infinity,a:1,b:2};
      for(let a=1;a<units.length-1;a++) for(let b=a+1;b<units.length;b++) {
        const first = units.slice(0,a).reduce((sum,unit)=>sum+unit.weight,0);
        const second = units.slice(a,b).reduce((sum,unit)=>sum+unit.weight,0);
        const third = total-first-second;
        const score = Math.abs(first-total/3)+Math.abs(second-total/3)+Math.abs(third-total/3);
        if(score<best.score) best={score,a,b};
      }
      const ranges = [units.slice(0,best.a),units.slice(best.a,best.b),units.slice(best.b)];
      chapters = ranges.map((group) => {
        const body=document.createElement('div');
        body.className='v2-article-body';
        group.forEach((unit,index)=>{
          if(index){
            const subheading=document.createElement('h3');
            for(const attribute of [...unit.heading.attributes]) subheading.setAttribute(attribute.name,attribute.value);
            subheading.append(...unit.heading.childNodes);
            body.append(subheading);
          }
          body.append(...unit.nodes);
        });
        return {heading:group[0].heading,body,title:group[0].heading.textContent};
      });
    }
    if (chapters.length < 3) return;
    root.dataset.readingReady = 'true';
    const toc = opening.querySelector('.v2-article-toc');
    if(toc){
      const details=document.createElement('details');
      details.className='v3-article-index';
      const summary=document.createElement('summary');
      summary.textContent=root.dataset.sectionLabel;
      details.append(summary,toc);
      route.after(details);
    }
    if(normalize(opening.textContent) || opening.querySelector('img,iframe,video')) source.before(opening);
    chapters.forEach((chapter,index)=>{
      const section=document.createElement('section');
      section.className='v3-article-chapter';
      section.id=`ReadingPart-${root.closest('[id]')?.id || 'article'}-${index+1}`;
      section.tabIndex=-1;
      const header=document.createElement('header');
      header.className='v3-chapter-heading';
      const number=document.createElement('span');
      number.className='v3-chapter-number';
      number.setAttribute('aria-label',`${root.dataset.partLabel} ${index+1}`);
      number.textContent=String(index+1).padStart(2,'0');
      header.append(number,chapter.heading);
      section.append(header,chapter.body);
      source.before(section);
      for(const paragraph of [...chapter.body.children]) if(paragraph.tagName==='P') splitParagraph(paragraph);
      const interlude=root.querySelector(`[data-reading-interlude="${index+1}"]`);
      if(interlude && index<chapters.length-1) section.after(interlude);
      const item=document.createElement('li');
      const link=document.createElement('a');
      link.href=`#${section.id}`;
      const routeNumber=document.createElement('span');
      routeNumber.className='v3-route-number';
      routeNumber.textContent=String(index+1).padStart(2,'0');
      routeNumber.setAttribute('aria-hidden','true');
      const title=document.createElement('span');
      title.className='v3-route-title';
      title.textContent=normalize(chapter.title).replace(/^\d+[.)]\s*/, '');
      link.append(routeNumber,title);
      item.append(link);
      routeList.append(item);
    });
    source.remove();
    route.hidden=false;
    routeList.addEventListener('click',event=>{
      const link=event.target.closest('a');
      if(!link) return;
      const target=document.getElementById(link.hash.slice(1));
      if(target) target.focus({preventScroll:true});
    });
    if(location.hash){
      let fragment=location.hash.slice(1);
      try { fragment=decodeURIComponent(fragment); } catch {}
      const destination=document.getElementById(fragment);
      if(destination){
        const details=destination.closest('details');
        if(details) details.open=true;
      }
    }
  };
  const initialize = (container) => container.querySelectorAll('[data-vivid-reading]').forEach(enhance);
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();


(() => {
  'use strict';
  if (window.top !== window.self || window.__vividMeasurementInstalled || window.Shopify?.designMode) return;
  const node = document.getElementById('vivid-measurement-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const id = config.measurementId;
  if (!/^G-[A-Z0-9]+$/.test(id || '')) return;
  const privateRoute = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:account|checkout|checkouts|orders|challenge|password)(?:\/|$)/i;
  if (privateRoute.test(window.location.pathname) || new URLSearchParams(window.location.search).has('preview_theme_id')) return;
  if (window.gtag || window.google_tag_manager || document.querySelector('script[src*="googletagmanager.com/gtag/js"], script[src*="googletagmanager.com/gtm.js"]')) return;
  if (window.dataLayer?.length) return;
  window.__vividMeasurementInstalled = true;
  const disabledKey = 'ga-disable-' + id;
  window[disabledKey] = true;

  const cleanLocation = () => {
    try {
      const url = new URL(config.pageLocation, window.location.origin);
      if (url.origin !== window.location.origin || privateRoute.test(url.pathname)) return '';
      return url.origin + url.pathname;
    } catch (_) { return ''; }
  };
  const cleanReferrer = () => {
    try {
      const url = new URL(document.referrer);
      return /^https?:$/.test(url.protocol) ? url.origin + '/' : '';
    } catch (_) { return ''; }
  };
  const page = {
    page_location: cleanLocation(),
    page_referrer: cleanReferrer(),
    page_title: typeof config.pageTitle === 'string' ? config.pageTitle : 'Vivid Web Consulting'
  };
  if (!page.page_location) return;
  let started = false;
  let ready = false;
  let configured = false;
  let pageSent = false;
  let leadObserved = false;
  let granted = false;
  let pending = [];
  let gtag;
  const consent = allowed => ({
    analytics_storage: allowed ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });
  const permission = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true && privacy.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  };
  const emit = (name, parameters) => {
    if (!ready || !configured || !permission()) return;
    gtag('event', name, { ...page, ...parameters, send_to: id });
  };
  const activate = () => {
    if (!ready || !permission()) return;
    window[disabledKey] = false;
    gtag('consent', 'update', consent(true));
    if (!configured) {
      gtag('set', { ...page, allow_google_signals: false, allow_ad_personalization_signals: false });
      gtag('config', id, { ...page, send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      configured = true;
    }
    if (!pageSent) {
      pageSent = true;
      emit('page_view', {});
    }
    const accepted = pending;
    pending = [];
    accepted.forEach(event => emit(event.name, event.parameters));
  };
  const start = () => {
    if (started || !permission()) return;
    started = true;
    if (window.gtag || window.google_tag_manager || window.dataLayer?.length || document.querySelector('script[src*="googletagmanager.com/gtag/js"], script[src*="googletagmanager.com/gtm.js"]')) return;
    window.dataLayer = window.dataLayer || [];
    gtag = function () { window.dataLayer.push(arguments); };
    window.gtag = gtag;
    gtag('consent', 'default', consent(false));
    gtag('js', new Date());
    const script = document.createElement('script');
    script.async = true;
    script.referrerPolicy = 'no-referrer';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    script.onload = () => { ready = true; syncConsent(); };
    script.onerror = () => { pending = []; };
    document.head.appendChild(script);
  };
  const syncConsent = () => {
    const allowed = permission();
    if (!allowed) {
      window[disabledKey] = true;
      pending = [];
      if (gtag && granted) gtag('consent', 'update', consent(false));
      granted = false;
      return;
    }
    granted = true;
    start();
    activate();
  };
  const record = (name, parameters) => {
    if (!permission()) return;
    syncConsent();
    if (ready) emit(name, parameters);
    else if (pending.length < 10) pending.push({ name, parameters });
  };
  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('vivid:quote-accepted', () => {
    if (leadObserved) return;
    leadObserved = true;
    record('generate_lead', { lead_type: 'project_quote', form_id: 'project_quote' });
  });
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    let url;
    try { url = new URL(link.getAttribute('href'), window.location.origin); } catch (_) { return; }
    if (url.protocol === 'mailto:') record('contact_click', { contact_method: 'email' });
    else if (url.protocol === 'https:' && ['calendar.app.google', 'calendar.google.com'].includes(url.hostname)) {
      record('booking_open', { booking_provider: 'google_calendar' });
    }
  });
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
})();
